var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4,18 L 4,6 C 4,4.896 4.895,4 6,4 L 18,4 C 19.104,4 20,4.896 20,6 L 20,18 C 20,19.105 19.104,20 18,20 L 6,20 C 4.895,20 4,19.105 4,18 Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5,18 C 5,17.819 5,6.183 5,6 C 5,5.448 5.448,5 6,5 C 6.181,5 17.817,5 18,5 C 18.552,5 19,5.448 19,6 C 19,6.183 19,17.819 19,18 C 19,18.552 18.552,19 18,19 C 17.817,19 6.181,19 6,19 C 5.448,19 5,18.552 5,18 Z",
    fill: "#eeeeee"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStop);
export default __webpack_public_path__ + "static/media/ic_stop.e547a8c782971219bb8aea850db67d87.svg";
export { ForwardRef as ReactComponent };